import { Controller } from "@hotwired/stimulus"

const MAX_LOOKUP_ATTEMPTS = 10

export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    if (!this.targetValue) return

    const [categoryId, yearMonth] = this.targetValue.split(":")
    if (!categoryId || !yearMonth) return

    const row = this.element.querySelector(`tr.cash-flow-row-category[data-category-id="${CSS.escape(categoryId)}"]`)
    if (!row) return

    const monthStart = `${yearMonth}-01`
    const cell = Array.from(row.querySelectorAll("td.cash-flow-amount.is-clickable")).find(td => {
      const raw = td.dataset.cashFlowDrilldownUrlValue || ""
      const query = raw.split("?")[1] || ""
      const params = new URLSearchParams(query)
      return params.get("start_date") === monthStart
    })
    if (!cell) return

    cell.scrollIntoView({ block: "center", behavior: "smooth" })
    this.expandCell(cell, 0)
  }

  expandCell(cell, attempt) {
    const controller = this.application.getControllerForElementAndIdentifier(cell, "cash-flow-drilldown")
    if (controller) {
      controller.toggle(new Event("click"))
      return
    }

    if (attempt >= MAX_LOOKUP_ATTEMPTS) return

    requestAnimationFrame(() => this.expandCell(cell, attempt + 1))
  }
}
